// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M3 2V8C3 9.1 3.9 10 5 10H13', 'M9 6L13 10L9 14'];
